import React from 'react';
import styled from 'styled-components';

import { H1, H3 } from 'partials/typography';
import Container from 'partials/Container';

export default props => {
    const { data, page } = props;
    const pageBackground = page && page.acf && page.acf.page_background ? page.acf.page_background : 'white';
    return (
        <Wrapper pageBackground={pageBackground} titlePlacement={data.title_placement}>
            <Container small flex direction="column" justify="flex-end">
                <H1>{data.title || page.title.rendered}</H1>
                <H3>{data.description || page.description.rendered}</H3>
            </Container>
        </Wrapper>
    );
}

const Wrapper = styled.div`
    padding-top: 120px;
    padding-bottom: 120px;
    @media(max-width: 767px) {
        padding-top: 20px;
        padding-bottom: 50px;
    }
    h1 {
        width:60%;
        ${props => props.pageBackground === 'main' ? `
            color: white;
        ` : ``}
        @media(max-width: 767px) {
            width: 100%;
            padding-left:0;
        }

        ${props => props.titlePlacement === 'left' ? `
            width:100%;
            padding-left:0;
            max-width: 960px;
            margin-left:auto;
            margin-right:auto;
        ` : ``}

        ${props => props.titlePlacement === 'center' ? `
            width:100%;
            padding-left:0;
            text-align:center;
        ` : ``}
    }

    h3 {
    	padding-top: 30px;
        width:50%;
        ${props => props.pageBackground === 'main' ? `
            color: white;
        ` : ``}
        @media(max-width: 767px) {
            width: 100%;
            padding-left:0;
        }

        ${props => props.titlePlacement === 'left' ? `
            width:100%;
            padding-left:0;
            max-width: 960px;
            margin-left:auto;
            margin-right:auto;
        ` : ``}

        ${props => props.titlePlacement === 'center' ? `
            width:100%;
            padding-left:0;
            text-align:center;
        ` : ``}
    }
`


// WEBPACK FOOTER //
// ./src/partials/modules/TitleAndDescription.js